var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wkb-evidence-table" },
    [
      _vm.title || _vm.$slots.controls
        ? _c(
            "div",
            { staticClass: "wkb-evidence-table-head" },
            [
              _vm.title
                ? _c("h4", { staticClass: "wkb-evidence-table-title" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ])
                : _vm._e(),
              _vm._t("controls"),
            ],
            2
          )
        : _vm._e(),
      _vm.rows.length
        ? _c(
            "div",
            {
              staticClass: "wkb-evidence-table-wrap",
              class: { "wkb-evidence-table-wrap--plain": !_vm.bordered },
            },
            [
              _c("table", { staticClass: "wkb-evidence-table-grid" }, [
                _c("thead", [
                  _c(
                    "tr",
                    _vm._l(_vm.columns, function (column) {
                      return _c(
                        "th",
                        { key: column.key, attrs: { scope: "col" } },
                        [_vm._v(" " + _vm._s(column.label) + " ")]
                      )
                    }),
                    0
                  ),
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.pagedRows, function (row, index) {
                    return _c(
                      "tr",
                      { key: _vm.rowKey(row, index) },
                      _vm._l(_vm.columns, function (column) {
                        return _c(
                          "td",
                          { key: column.key, class: _vm.cellClass(column) },
                          [
                            column.slot
                              ? _vm._t(column.slot, null, {
                                  row: row,
                                  value: row[column.key],
                                })
                              : [_vm._v(_vm._s(_vm.formatCell(row, column)))],
                          ],
                          2
                        )
                      }),
                      0
                    )
                  }),
                  0
                ),
              ]),
            ]
          )
        : _c("p", { staticClass: "wkb-evidence-table-empty" }, [
            _vm._v(_vm._s(_vm.emptyNote)),
          ]),
      _vm.rows.length
        ? _c("WorkspaceGraphTablePagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "total-pages": _vm.totalPages,
              "aria-label": _vm.paginationLabel,
            },
            on: {
              "page-change": function ($event) {
                _vm.currentPage = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }